import { render } from "./S97861.vue?vue&type=template&id=7f97afa0"
const script = {}
script.render = render

export default script